import React from 'react'
import { Link } from 'react-router-dom'

const items = [
	{
		id: 1,
		label: "Submitted",
		href: "/submitted",
		type: "submitted",
		svg: <svg viewBox="0 0 512 512"><path d="M500 124H140c-6.627 0-12-5.373-12-12V80c0-6.627 5.373-12 12-12h360c6.627 0 12 5.373 12 12v32c0 6.627-5.373 12-12 12zm12 148v-32c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12zm0 160v-32c0-6.627-5.373-12-12-12H140c-6.627 0-12 5.373-12 12v32c0 6.627 5.373 12 12 12h360c6.627 0 12-5.373 12-12zM92 128V64c0-6.627-5.373-12-12-12H16C9.373 52 4 57.373 4 64v64c0 6.627 5.373 12 12 12h64c6.627 0 12-5.373 12-12zm0 160v-64c0-6.627-5.373-12-12-12H16c-6.627 0-12 5.373-12 12v64c0 6.627 5.373 12 12 12h64c6.627 0 12-5.373 12-12zm0 160v-64c0-6.627-5.373-12-12-12H16c-6.627 0-12 5.373-12 12v64c0 6.627 5.373 12 12 12h64c6.627 0 12-5.373 12-12z"></path></svg>
	},
	{
		id: 2,
		label: "Upvotes",
		href: "/upvotes",
		type: "upvotes",
		svg: <svg viewBox="0 0 576 512"><path d="M257.3 475.4L92.5 313.6C85.4 307 24 248.1 24 174.8 24 84.1 80.8 24 176 24c41.4 0 80.6 22.8 112 49.8 31.3-27 70.6-49.8 112-49.8 91.7 0 152 56.5 152 150.8 0 52-31.8 103.5-68.1 138.7l-.4.4-164.8 161.5a43.7 43.7 0 0 1-61.4 0zM125.9 279.1L288 438.3l161.8-158.7c27.3-27 54.2-66.3 54.2-104.8C504 107.9 465.8 72 400 72c-47.2 0-92.8 49.3-112 68.4-17-17-64-68.4-112-68.4-65.9 0-104 35.9-104 102.8 0 37.3 26.7 78.9 53.9 104.3z"></path></svg>
	},
	{
		id: 3,
		label: "Bookmarked",
		href: "/bookmarked",
		type: "bookmarked",
		svg: <svg viewBox="0 0 384 512"><path d="M336 0H48C21.49 0 0 21.49 0 48v464l192-112 192 112V48c0-26.51-21.49-48-48-48zm0 428.43l-144-84-144 84V54a6 6 0 0 1 6-6h276c3.314 0 6 2.683 6 5.996V428.43z"></path></svg>
	}
]

class SideItem extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			active: false
		}
	}
	
	componentWillReceiveProps(nextProps) {
		const { active } = nextProps
		if (active) {
			this.setState({
				active: true
			})
		} else {
			this.setState({
				active: false
			})
		}
	}
	
	componentDidMount() {
		const { active } = this.props
		if (active) {
			this.setState({
				active: true
			})
		}
	}
	
	render() {
		
		const { item, profile_id } = this.props
		const { id, label, href, svg } = item
		const { active } = this.state
				
		return (
			<li>
				<Link to={ '/profile/' + profile_id + href }>
					{ active ? (
						<div className="nav-tab active">
							<span className="icon">{ svg }</span>
							<span className="label">{ label }</span>
						</div>
					) : (
						<div className="nav-tab">
							<span className="icon">{ svg }</span>
							<span className="label">{ label }</span>
						</div>
					)}
				</Link>
			</li>
		)
	}
}

class BaseController extends React.Component {
	
	constructor(props) {
		super(props)
		this.state = {
			path: ''
		}
	}
	
	componentWillMount() {
		const { pathname } = this.props
		const path = pathname.params.type ? '/profile/' + pathname.params.profile_id + pathname.params.type : '/profile/' + pathname.params.profile_id
		this.setState({
			path: path
		})
	}

    render() {
        return null
    }
}

class Sidebar extends BaseController {
	
	componentWillReceiveProps(nextProps) {
		const path = nextProps.pathname.params.type ? '/profile/' + nextProps.pathname.params.profile_id + nextProps.pathname.params.type : '/profile/' + nextProps.pathname.params.profile_id
		
		this.setState({
			path: path
		})
	}

	render() {
		
		const { pathname } = this.props
		const profile_id = pathname.params.profile_id
		const type = pathname.params.type
		
		const sideitems = items.map((item, index) => {
			if (type) {
				if (item.type === type) {
					return (
						<SideItem
							key={ item.id }
							item={ item }
							profile_id={ profile_id }
							active={ true }
						/>
					)
				}
				return (
					<SideItem
						key={ item.id }
						item={ item }
						profile_id={ profile_id }
						active={ false }
					/>
				)
			} else {
				if (index === 0) {
					return (
						<SideItem
							key={ item.id }
							item={ item }
							profile_id={ profile_id }
							active={ true }
						/>
					)
				}
				return (
					<SideItem
						key={ item.id }
						item={ item }
						profile_id={ profile_id }
						active={ false }
					/>
				)
			}
		})
		
		return (
			<div className="sidebar">
				<ul>
					{ sideitems }
				</ul>
			</div>
		)
	}
}

export default Sidebar


// WEBPACK FOOTER //
// ./src/components/Profile/Sidebar.js